var impressum = "Impresum";
var privacy = "Ochrana osobních údajů a právní informace";
var recallInfo = "Informace o svolávacích akcích";
var signOut = "Odhlásit se";
var cs_cz = {
	impressum: impressum,
	privacy: privacy,
	recallInfo: recallInfo,
	signOut: signOut
};

export { cs_cz as default, impressum, privacy, recallInfo, signOut };
